import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

export type SideRailSide = 'left' | 'right';

type ChevronIcon = typeof ChevronLeftIcon;

export const COLLAPSED_RAIL_WIDTH_PX = 44;

// A rail collapses toward its own page edge and expands back toward the centre.
export const COLLAPSE_ICON: Record<SideRailSide, ChevronIcon> = {
    left: ChevronLeftIcon,
    right: ChevronRightIcon
};

export const EXPAND_ICON: Record<SideRailSide, ChevronIcon> = {
    left: ChevronRightIcon,
    right: ChevronLeftIcon
};

export const LABEL_TOOLTIP_SIDE: Record<SideRailSide, SideRailSide> = {
    left: 'right',
    right: 'left'
};
